import {
  css, Global, ThemeProvider,
} from '@emotion/react';
import type { ReactNode } from 'react';
import { lightTheme } from '~/_shared/themes/light.theme';
import type { Theme } from '~/_shared/themes/theme.model';

const globalStyle = (theme: Theme) => css`
  @page {
    size: A4 portrait;
    margin: 2mm;
    background: ${theme.reportColors.backgroundPrimary};
  }
  body {
    background: ${theme.reportColors.backgroundPrimary};
    color: ${theme.reportColors.textPrimary};
  }
  #root {
    overflow: visible !important;
  }
`;
/**
 * This is a ratio that allows conversion from mm to px. It was determined empirically
 */
const scaleMmToFitPage = (size: number) => `${270 / 210 * size}mm`;

const wrapperStyle = css({
  position: 'relative',
  width: scaleMmToFitPage(190),
  margin: '0 auto',
  boxSizing: 'border-box',
  paddingBottom: 20,
});

type ExportReportPrintPageWrapperProps = Readonly<{
  children: ReactNode;
}>;

export const ExportReportPrintPageWrapperComponent = (props: ExportReportPrintPageWrapperProps) => {
  return (
    <ThemeProvider theme={lightTheme}>
      <div css={wrapperStyle}>
        <Global styles={globalStyle} />
        {props.children}
      </div>
    </ThemeProvider>
  );
};
